import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';
import { Card } from '@/components/ui/card';
import { Clock, Shield, FileText, LogIn } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminAuditLogPage = () => {
  const { getAuthHeaders } = useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/admin/audit-log?limit=100`, { headers: getAuthHeaders() });
        setLogs(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    load();
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" /></div>;

  const iconMap = {
    'REGISTRO': LogIn, 'LOGIN': LogIn, 'PIN_CONFIGURADO': Shield, 'PIN_FALLIDO': Shield,
    'CHAT_ENVIADO': FileText, 'RECIBO_DESCARGADO': FileText,
  };

  const colorMap = {
    'REGISTRO': 'bg-green-100 text-green-600', 'LOGIN': 'bg-blue-100 text-blue-600',
    'PIN_CONFIGURADO': 'bg-violet-100 text-violet-600', 'PIN_FALLIDO': 'bg-red-100 text-red-600',
    'CHAT_ENVIADO': 'bg-amber-100 text-amber-600', 'RECIBO_DESCARGADO': 'bg-emerald-100 text-emerald-600',
  };

  return (
    <div className="space-y-6" data-testid="admin-audit-log-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Historial de Auditorias</h1>
        <p className="text-slate-500">Registro de actividad de clientes</p>
      </div>

      {logs.length === 0 ? (
        <Card className="p-12 text-center border-0 shadow-sm">
          <Clock className="w-12 h-12 mx-auto text-slate-300 mb-3" />
          <p className="text-slate-500">Sin registros de auditoria</p>
        </Card>
      ) : (
        <Card className="border-0 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-slate-50 border-b">
                  <th className="text-left p-3 font-medium text-slate-600">Accion</th>
                  <th className="text-left p-3 font-medium text-slate-600">Usuario</th>
                  <th className="text-left p-3 font-medium text-slate-600">Detalles</th>
                  <th className="text-left p-3 font-medium text-slate-600">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => {
                  const Icon = iconMap[log.action] || Clock;
                  const color = colorMap[log.action] || 'bg-slate-100 text-slate-600';
                  return (
                    <tr key={log.id} className="border-b hover:bg-slate-50" data-testid={`audit-row-${log.id}`}>
                      <td className="p-3">
                        <div className="flex items-center gap-2">
                          <div className={`w-7 h-7 rounded-lg ${color} flex items-center justify-center`}>
                            <Icon className="w-3.5 h-3.5" />
                          </div>
                          <span className="font-medium">{log.action}</span>
                        </div>
                      </td>
                      <td className="p-3 text-slate-600">{log.user_id?.slice(0, 8)}...</td>
                      <td className="p-3 text-slate-500">{log.details || '—'}</td>
                      <td className="p-3 text-slate-400 whitespace-nowrap">{new Date(log.created_at).toLocaleString('es-ES')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
};

export default AdminAuditLogPage;
